<div class="filter">
	<div class="filter__search">
		<input
			type="text"
			id="search"
			name="searchClients"
			[(ngModel)]="data"
			class="input-app input-search"
			[placeholder]="placeholder"
		/>
		<mat-icon class="icon-filter hover:text-primary-color" (click)="viewOptions()">tune</mat-icon>
		<p-menu *ngIf="activeOptions" class="menu-table" [model]="items"></p-menu>
	</div>
	<div class="filter__chips" [ngStyle]="calcWidth()">
		<mat-chip-listbox #chipList>
			<mat-chip [removable]="removable" *ngFor="let item of chips" (removed)="removeItem(item)">
				<span class="whitespace-nowrap text-primary-color"> {{ item.label | titlecase }}: </span>
				<span class="whitespace-nowrap text-primary-color"> &#160;{{ item.selected }} </span>
				<button matChipRemove>
					<mat-icon>cancel</mat-icon>
				</button>
			</mat-chip>
		</mat-chip-listbox>
	</div>
</div>
